import Vue from "vue";
import Vuex from "vuex";
import loginState from "@/views/login/store";
import meState from "@/views/apps/store";
import usersState from "@/views/admin/user/store";
import logsState from "@/views/admin/logs/store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    loginState,
    meState,
    usersState,
    logsState,
  },
});
